var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_532_3476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9083 2.4629L20.9421 3.35782L21.7981 11.7567L12.6265 21.3451C12.2035 21.7874 11.664 22.0717 11.1267 22.1354C10.5894 22.1991 10.0983 22.0371 9.76153 21.685L3.41171 15.0466C3.07489 14.6944 2.91992 14.181 2.98089 13.6193C3.04185 13.0576 3.31376 12.4936 3.73679 12.0513L12.9083 2.4629Z",
    stroke: "#1479FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.087,
    cy: 6.13636,
    rx: 1.08696,
    ry: 1.13636,
    fill: "#1479FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30306 14.6077C7.0003 14.2911 6.851 13.9529 6.85514 13.5931C6.85929 13.2245 7.0003 12.895 7.27817 12.6045C7.55604 12.314 7.86917 12.1687 8.21754 12.1687C8.56592 12.1601 8.89149 12.314 9.19424 12.6305C9.497 12.947 9.6463 13.2896 9.64215 13.6581C9.64215 14.0223 9.50322 14.3497 9.22535 14.6402C8.94748 14.9307 8.63228 15.0781 8.27975 15.0824C7.93138 15.0824 7.60581 14.9242 7.30306 14.6077ZM10.2083 9.71032L12.0559 16.832L11.3592 17.5604L9.51151 10.4387L10.2083 9.71032ZM7.70742 13.0533C7.44614 13.3264 7.49591 13.6516 7.85673 14.0288C8.22169 14.4104 8.53482 14.4646 8.7961 14.1914C8.92052 14.0613 8.97236 13.9161 8.95162 13.7557C8.93089 13.5866 8.8272 13.4045 8.64057 13.2093C8.27975 12.8321 7.9687 12.7801 7.70742 13.0533ZM12.3794 14.6207C12.0766 14.3042 11.9273 13.966 11.9315 13.6061C11.9356 13.2375 12.0766 12.908 12.3545 12.6175C12.6282 12.3313 12.9393 12.1883 13.2877 12.1883C13.636 12.1796 13.9616 12.3335 14.2644 12.65C14.5671 12.9665 14.7164 13.3091 14.7123 13.6776C14.7123 14.0418 14.5754 14.367 14.3017 14.6532C14.0238 14.9437 13.7086 15.0911 13.3561 15.0954C13.0077 15.0954 12.6822 14.9372 12.3794 14.6207ZM12.7775 13.0728C12.5163 13.3459 12.566 13.6711 12.9268 14.0483C13.2877 14.4256 13.5987 14.4776 13.86 14.2044C14.1213 13.9313 14.0715 13.6061 13.7107 13.2289C13.3499 12.8516 13.0388 12.7996 12.7775 13.0728Z",
    fill: "#1479FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_532_3476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 25) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.a7791447ed1400606690dcd420266c3d.svg";
export { ForwardRef as ReactComponent };